var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-container"},[_c('HeaderMod'),_c('LoginReg'),_c('FooterMod')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }